import * as THREE from 'three';
import Bubble from './Bubble/Bubble';

class HighlightedBubble extends THREE.Group {
  constructor({
    title, artist, posY, posZ, color, index, ...rest
  }) {
    super();

    const innerLight = new THREE.PointLight(color, 100, 3, 2);
    innerLight.castShadow = true;
    innerLight.shadow.bias = -0.005;

    this.add(innerLight);

    const titleBubble = new Bubble({ displayMessage: title, ...rest });
    this.bubble = titleBubble;
    titleBubble.show();

    this.add(titleBubble);
    this.userData.artist = artist;
    this.userData.songIndex = index;
    this.position.set(0, posY, posZ);
  }

  setSound(sound) {
    this.sound = sound;
  }
}

export default HighlightedBubble;
